import { Component, OnInit } from '@angular/core';
import { FinishProService } from '../../services/finish-pro.service';
import { LoadingProService } from '../../services/loading-pro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomMetadataOperation } from '../../models/operations/metadata';

@Component({
  selector: 'app-simple-sign',
  templateUrl: './simple-sign.component.html',
  styleUrls: ['./simple-sign.component.scss']
})
export class SimpleSignComponent implements OnInit {

  constructor(
    private _finish: FinishProService,
    private _loadingPro: LoadingProService,
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.downloadDocuments();
  }

  private async downloadDocuments(): Promise<void> {
    this._loadingPro.getOperationTypeProps(this._finish.getOperationType());
    this._loadingPro.setLoader(false);
    this._loadingPro.setNextOperationLoader(true);
    const metadata = await this._finish.getMetadata();

    try {
      await this._finish.getDownloadDocumentsCircuit();

      setTimeout(() => {
        this.finishOperation(metadata);
      }, 1000);
    } catch (e) {
      console.log(e);
      this._loadingPro.setNextOperationLoader(false);
    }
  }

  private async finishOperation(metadata: CustomMetadataOperation[]): Promise<void> {
    metadata.push({ key: 'privacyPolicyAccepted', value: true });
    await this._finish.putFinishOperation(true, metadata);
    const route = this._finish.getRoutePath();
    this._router.navigate([route], { relativeTo: this._route.parent });
    this._loadingPro.setNextOperationLoader(false);
    this._getRoute();
  }

  private _getRoute(): void {
    const operationId = this._finish.operationId;
    const hasNextOperation = !!operationId;

    if (hasNextOperation) {
      this._loadingPro.setNextOperationLoader(true);
      this._finish.operationRequest.hasFinishCircuit = true;
      this._finish.operationRequest.idDocument = null;
      this._finish.operationRequest.documentList = null;
      this._finish.documentsReaded = [];
    }

    const route = this._finish.getRoutePath();
    const path = hasNextOperation ? `../${operationId}/${route}` : route;

    const CUSTOM_TIMEOUT: number = 500;
    setTimeout(() => this._router.navigate([path], { relativeTo: this._route.parent }), CUSTOM_TIMEOUT);
  }

}
